













import { Modal, notify, ModalMixin } from 'mycorems-app-shared';
import HasTaskMixin from '../components/HasTaskMixin';
import { ModalElement } from '../types';
import { deleteUser } from '.';

export default HasTaskMixin.extend({
  mixins: [ModalMixin],
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  methods: {
    onDelete(): void {
      this.task = deleteUser(this.id);
      this.task.then(() => {
        this.$emit('ok');
        (this.$refs.modal as ModalElement).hide();
        notify.success('User deleted.');
      });
    },
  },
  components: {
    modal: Modal,
  },
});
